<template>
    <v-tooltip bottom>
        <template v-slot:activator="{ on }">
            <v-icon v-on="on" class="action mx-1" :color="color" x-small :disabled="disabled" @click="actionClick" v-if="size==='x-small'">{{ icon }}</v-icon>
            <v-icon v-on="on" class="action mx-1" :color="color" small   :disabled="disabled" @click="actionClick" v-if="size==='small'"  >{{ icon }}</v-icon>
            <v-icon v-on="on" class="action mx-1" :color="color" default :disabled="disabled" @click="actionClick" v-if="size==='default'">{{ icon }}</v-icon>
            <v-icon v-on="on" class="action mx-1" :color="color" large   :disabled="disabled" @click="actionClick" v-if="size==='large'"  >{{ icon }}</v-icon>
            <v-icon v-on="on" class="action mx-1" :color="color" x-large :disabled="disabled" @click="actionClick" v-if="size==='x-large'">{{ icon }}</v-icon>
        </template>
        <span v-html="convertTextToHtml(tooltip)"></span>
    </v-tooltip>
</template>

<script>
    export default{ 
        props: {
            data: {
                required: true,               
            },
            icon: {
                type: String,
                required: false,  
                default: ""            
            },  
            tooltip: {
                type: String,
                required: false,
                default: "Click me",
            },    
            size: {
                type: String,
                required: false,
                default: "default",
            },
            color: {
                type: String,
                required: false,
                default: "black",
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false,                
            }
        },
        data() {
            return {
            }
        },
        computed: {
            btnClass: function () {
                return "action mx-1 " + this.color;
            }
        }, 
        methods: {
            actionClick() {
                this.$emit("actionClick", this.data);
            },            
            convertTextToHtml(text) {
                return text.replace(/\n/gi, '<br>'); // yes indeed, regular expression!!
            },
        },
    }

</script>

<style scoped>
    .action {
        cursor: pointer;
    }
</style>